// extracted by mini-css-extract-plugin
export default {"secondaryHeader":"pages_secondaryHeader__JX4vG","content":"pages_content__-M9SM","full":"pages_full__u2ROO","third":"pages_third__PIcXU","about":"pages_about__yfNOG"};